var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"lg aboutus"},[_c('img',{staticClass:"wid750",attrs:{"src":require("../../assets/imgs/aboutus.jpg"),"alt":""}})]),_c('div',{staticClass:"zrl zrlaboutus"},[_c('img',{staticClass:"zrlwid750",attrs:{"src":require("../../assets/imgs/aboutus.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }